// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","wrapper":"wrapper-2SyeM","left":"left-3uM8F","right":"right-2ByHV","title":"title-2f4op"};